import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="bg-blush py-20 md:py-28 px-6" data-id="element-156">
      <div className="max-w-reading mx-auto" data-id="element-157">
        <FadeIn data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-serif text-forest mb-10" data-id="element-159">
            The Sunday Scaries thrive on ambiguity.
          </h2>
          <div className="space-y-6 text-lg text-charcoal/90 font-light" data-id="element-160">
            <p data-id="element-161">
              You feel paralyzed because your brain is trying to solve a week's
              worth of problems while you're trying to sleep.
            </p>
            <p data-id="element-162">
              You spend Sunday night "revenge scrolling" TikTok to reclaim your
              time, only to wake up Monday morning more exhausted, reactive, and
              resentful than when you left work on Friday.
            </p>
            <p className="font-medium text-forest" data-id="element-163">
              You aren't lazy, and you aren't failing at "adulting."
            </p>
            <p data-id="element-164">
              You are just trying to fight a biological stress response with a
              logistical planner that wasn't built for a burnt-out brain.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}